import { faker } from '@faker-js/faker';

import type { ChangeInvestorCreditSplitPostResponse } from '../types/ChangeInvestorCreditSplitPostResponse';

export function createChangeInvestorCreditSplitPostResponse(
  data: NonNullable<Partial<ChangeInvestorCreditSplitPostResponse>> = {}
): NonNullable<ChangeInvestorCreditSplitPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
